/**
 * Copyright (c) 2022 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */

import React from 'react';
import { css, StyleSheet } from 'aphrodite';
import { docSubheaderHeight } from '../DocSubheaderWrapper/DocSubheaderWrapper';

import SigningDocument from '../Documents/SigningDocument';
import { mediaBreakpoints } from '../../../common/responsive';
import { ESignProviders } from '@shared/constants/document';

export namespace DocumentSigningIframe {
  export interface Props {
    selectedDocument: SigningDocument | undefined;
    shouldShowEditIframe: boolean;
    editUrl: string | undefined;
    signingUrl: string;
  }
}

const previewHeaderHeight = 48;
const docuSignFooterHeight = 35;

const styles = StyleSheet.create({
  docuSignDocWrapper: {
    height: '100%',
    display: 'block',
    overflowY: 'hidden',
  },
  oneSpanDocWrapper: {}, // TODO
  eNoteSigningDocWrapper: {}, // TODO
  docuSignIframe: {
    width: '100%',
    // Hide the footer
    height: `calc(100% + ${docuSignFooterHeight}px)`,
    border: 'none',
    [mediaBreakpoints.mobile]: {
      height: '100%',
    },
  },
  oneSpanIframe: {
    width: '100%',
    height: `100%`,
    border: 'none',
  },
  eNoteSigningIFrame: {
    width: '100%',
    height: `calc(100% - ${previewHeaderHeight}px - ${docSubheaderHeight}px)`,
    border: 'none',
  },
  docWrapper: {
    width: '100%',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
  },
});

const iframeStyleForESign = (eSignProvider: string | undefined) => {
  switch (eSignProvider) {
    case ESignProviders.ONESPAN:
      return styles.oneSpanIframe;
    case ESignProviders.DOCUSIGN:
      return styles.docuSignIframe;
    case ESignProviders.EORIGINAL:
      return styles.eNoteSigningIFrame;
    default:
      return styles.docuSignIframe;
  }
};

const docWrapperStyleForESign = (eSignProvider: string | undefined) => {
  switch (eSignProvider) {
    case ESignProviders.ONESPAN:
      return styles.oneSpanDocWrapper;
    case ESignProviders.DOCUSIGN:
      return styles.docuSignDocWrapper;
    case ESignProviders.EORIGINAL:
      return styles.eNoteSigningDocWrapper;
    default:
      return undefined;
  }
};

export const DocumentSigningIframe: React.FC<DocumentSigningIframe.Props> = ({
  selectedDocument,
  shouldShowEditIframe,
  editUrl,
  signingUrl,
}) => {
  return (
    <div className={css(styles.docWrapper, docWrapperStyleForESign(selectedDocument?.eSignProvider))}>
      <iframe
        className={css(iframeStyleForESign(selectedDocument?.eSignProvider))}
        src={shouldShowEditIframe ? editUrl : signingUrl}
        sandbox="allow-scripts allow-same-origin allow-forms"
      />
    </div>
  );
};
